<template>
  <app-layout-columns :max-width="115" :padding="false">
    <template #aside>
      <div>
        <squad-settings-menu :class="$style.squadMenu" />
      </div>
    </template>
    <div>
      <squad-settings-change
        v-if="settingsCurrentScreen === 'settings-info'"
        :squad="squad"
        @update="emit('update')"
      />
      <squad-settings-members
        v-else-if="settingsCurrentScreen === 'settings-members'"
        :members="squad.members"
        :free-slots="squad.free_slots"
        :squad-id="squad.id"
        :removing-members="props.removingMembers"
        :showing-free-slots="props.showingFreeSlots"
        @member-removed="handleMemberRemoved"
        @transfer="emit('update')"
      />
    </div>
  </app-layout-columns>
</template>

<script setup lang="ts">
import AppLayoutColumns from '~/components/layout/columns/index.vue'
import SquadSettingsMenu from './SquadSettingsMenu.vue'
import SquadSettingsChange from './SquadSettingsChange.vue'
import SquadSettingsMembers from './SquadSettingsMembers.vue'
import type { Squad } from '~/services/api'
import type { CurrentScreen } from '~/components/squads/squadPage/types'
import { useSquadsStore } from '~/stores/squads'
import { storeToRefs } from 'pinia'

const props = defineProps<{
  squad: Squad
  removingMembers?: Set<number>
  showingFreeSlots?: Set<number>
}>()

const emit = defineEmits<{
  (e: 'member-removed', memberId: number): void
  (e: 'update'): void
}>()

const squadsStore = useSquadsStore()
const { currentScreen } = storeToRefs(squadsStore)
const settingsCurrentScreen = computed<CurrentScreen>(() =>
  currentScreen.value === 'settings-members'
    ? 'settings-members'
    : 'settings-info'
)

const handleMemberRemoved = (memberId: number) => {
  emit('member-removed', memberId)
}
</script>

<style module lang="scss">
.squadMenu {
  @include down(md) {
    margin-bottom: 1em;
  }
}
</style>
